import { createSlice } from "@reduxjs/toolkit";
import { FetchErrorLogAsync } from "../thunk/ErrorLog";

let initialState = {
  errorLogList: "",
  errorLogListError: "",
  errorLogListStatus: "",
};
const ErrorLogSlice = createSlice({
  name: "ErrorLogSlice",
  initialState,
  reducer: {},
  extraReducers: (builder) => {
    builder.addCase(FetchErrorLogAsync.pending, (state) => {
      state.errorLogListStatus = "loading";
    });
    builder.addCase(FetchErrorLogAsync.fulfilled, (state, action) => {
      state.errorLogListStatus = "succeeded";
      state.errorLogList = action.payload;
    });
    builder.addCase(FetchErrorLogAsync.rejected, (state, action) => {
      state.errorLogListStatus = "failed";
      state.errorLogListError = action.error.message;
    });
  },
});

export default ErrorLogSlice.reducer;
